module.exports = __webpack_public_path__ + "assets/folder-plus.80ffe6af.svg";